module.exports = __webpack_public_path__ + "img/file-----3258@1x.da898f96.png";